import * as React from 'react';
import { Suspense, lazy } from 'react';
import { Route } from 'react-router';
import Layout from './components/Layout/Layout'
import { HomeComponent } from './components/Home/Home';
import HomePhysioComponent from './components/Home/HomePhysio';
import { LoaderComponent } from './controls/Loader';
import './App.css';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

//import LogInComponent from './components/LogIn/LogIn';
//import LogOutComponent from './components/LogIn/LogOut';
//import RegisterComponent from './components/LogIn/Register';
//import RegisterCodeConfirm from './components/LogIn/RegisterCodeConfirm';
//import AdvancedSearch from './components/Search/AdvancedSearch';
//import PhysiotherapistViewComponent from './components/PhysiotherapistView/PhysiotherapistView';
//import ArrangeVisitFirstStepComponent from './components/Visit/ArrangeVisitFirstStep';
//import ArrangeVisitSecondStepComponent from './components/Visit/ArrangeVisitSecondStep';
//import ArrangeVisitThirdStepComponent from './components/Visit/ArrangeVisitThirdStep';
//import { RegisterConfirmComponent } from './components/LogIn/RegisterConfirm';
//import { CustomerViewComponent } from './components/Customer/CustomerView';
//import { CustomerEditComponent } from './components/Customer/CustomerEdit';
//import { ClinicAddComponent } from './components/Clinic/ClinicAdd';
const LogInComponent = lazy(() => import('./components/LogIn/LogIn'));
const LogOutComponent = lazy(() => import('./components/LogIn/LogOut'));
const RegisterComponent = lazy(() => import('./components/LogIn/Register'));
const RegisterCodeConfirm = lazy(() => import('./components/LogIn/RegisterCodeConfirm'));
const AdvancedSearch = lazy(() => import('./components/Search/AdvancedSearch')); //Najcz�ciej wykorzystywane komponenty dobrze by�oby �adowa� od razu
const PhysiotherapistViewComponent = lazy(() => import('./components/PhysiotherapistView/PhysiotherapistView'));
const ArrangeVisitFirstStepComponent = lazy(() => import('./components/Visit/ArrangeVisitFirstStep'));
const ArrangeVisitSecondStepComponent = lazy(() => import('./components/Visit/ArrangeVisitSecondStep'));
const ArrangeVisitThirdStepComponent = lazy(() => import('./components/Visit/ArrangeVisitThirdStep'));
const RegisterConfirmComponent = lazy(() => import('./components/LogIn/RegisterConfirm'));
const CustomerViewComponent = lazy(() => import('./components/Customer/CustomerView'));
const CustomerEditComponent = lazy(() => import('./components/Customer/CustomerEdit'));
const ClinicAddComponent = lazy(() => import('./components/Clinic/ClinicAdd'));

//import { TherapiesSectionComponent } from './components/Therapy/TherapiesSection';
//import { TherapyAcceptListComponent } from './components/Therapy/TherapyAcceptList';
//import { DiseaseCategoryAcceptListComponent } from './components/DiseaseCategory/DiseaseCategoryAcceptList';
//import { TestComponent } from './components/Test/Test';
//import { EducationEditComponent } from './components/Education/EducationEdit';
//import { SchedulerComponent } from './components/Scheduler/Scheduler';
//import { FixedWorkHoursComponent } from './components/Scheduler/FixedWorkHours';
const TherapiesSectionComponent = lazy(() => import('./components/Therapy/TherapiesSection'));
const TherapyAcceptListComponent = lazy(() => import('./components/Therapy/TherapyAcceptList'));
const DiseaseCategoryAcceptListComponent = lazy(() => import('./components/DiseaseCategory/DiseaseCategoryAcceptList'));
const TrainingCoursesAcceptList = lazy(() => import('./components/AcceptList/TrainingCoursesAcceptList'));
const TestComponent = lazy(() => import('./components/Test/Test'));
const RouteTestComponent = lazy(() => import('./components/Test/RouteTest'));
const EducationEditComponent = lazy(() => import('./components/Education/EducationEdit'));
const SchedulerComponent = lazy(() => import('./components/Scheduler/Scheduler'));
const FixedWorkHoursComponent = lazy(() => import('./components/Scheduler/FixedWorkHours'));

//import { PhysiotherapistEditComponent } from './components/PhysiotherapistView/PhysiotherapistEdit';
//import { VisitListComponent } from './components/Visit/VisitList';
//import { VisitViewComponent } from './components/Visit/VisitView';
//import { RegisterFinalComponent } from './components/LogIn/RegisterFinal';
//import { PasswordRecoveryComponent } from './components/LogIn/PasswordRecovery';
//import { ResetPasswordComponent } from './components/LogIn/ResetPassword';
//import { FavoriteListComponent } from './components/Favorite/FavoriteList';
const PhysiotherapistEditComponent = lazy(() => import('./components/PhysiotherapistView/PhysiotherapistEdit'));
const VisitListComponent = lazy(() => import('./components/Visit/VisitList'));
const VisitViewComponent = lazy(() => import('./components/Visit/VisitView'));
const RegisterFinalComponent = lazy(() => import('./components/LogIn/RegisterFinal'));
const PasswordRecoveryComponent = lazy(() => import('./components/LogIn/PasswordRecovery'));
const ResetPasswordComponent = lazy(() => import('./components/LogIn/ResetPassword'));
const FavoriteListComponent = lazy(() => import('./components/Favorite/FavoriteList'));

//import { StatuteComponent } from './components/Statute/Statute';
//import { CustomerVisitListComponent } from './components/Visit/CustomerVisitList';
//import { AccountEditComponent } from './components/PhysiotherapistView/AccountEdit';
//import { VisitViewAnonymousComponent } from './components/Visit/VisitViewAnonymous';
const CustomerVisitListComponent = lazy(() => import('./components/Visit/CustomerVisitList'));
// const AccountEditComponent = lazy(() => import('./components/PhysiotherapistView/AccountEdit'));
const VisitViewAnonymousComponent = lazy(() => import('./components/Visit/VisitViewAnonymous'));
const NotFoundComponent = lazy(() => import('./components/Layout/NotFound'));
const ContactComponent = lazy(() => import('./components/Contact/Contact'));
const Blog = lazy(() => import('./components/Blog/Blog'));
const BlogArticle = lazy(() => import('./components/Blog/BlogArticle'));
const StatisticsComponent = lazy(() => import('./components/Admin/Statistics'));
const SitemapManageComponent = lazy(() => import('./components/Admin/SitemapManage'));
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy/PrivacyPolicy'));

class App extends React.Component {
  public render() {
      return (
        <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_v3} language="pl">
          <Layout>
            <Suspense fallback={<LoaderComponent Visible={true} />}>
                  <Route exact={true} path='/' component={HomeComponent} />
                  <Route exact={true} path='/dlafizjoterapeuty' component={HomePhysioComponent} />
                  <Route exact={true} path='/statute' component={HomeComponent} />
                <Route path='/login' component={LogInComponent} />
                <Route path='/logout' component={LogOutComponent} />
                <Route exact={true} path='/register' component={RegisterComponent} />
                <Route path='/register/confirm' component={RegisterConfirmComponent} />
                <Route path='/customer/view' component={CustomerViewComponent} />
                <Route path='/customer/account/edit' component={CustomerEditComponent} />
                <Route exact={true} path='/fizjoterapeuta' component={PhysiotherapistViewComponent} />
                  <Route exact={true} path='/physiotherapist/edit' component={PhysiotherapistEditComponent} />
                  <Route exact={true} path='/physiotherapist/edit/a' component={PhysiotherapistEditComponent} />
                <Route path='/fizjoterapeuta/:id_1/:id_2?/:id_3?/:id_4?/:id_5?' component={PhysiotherapistViewComponent} />
                <Route path='/addclinic' component={ClinicAddComponent} />
                  <Route path='/therapies/:id' component={TherapiesSectionComponent} />
                <Route path='/accept/therapy' component={TherapyAcceptListComponent} />
                  <Route path='/accept/diseasecategory' component={DiseaseCategoryAcceptListComponent} />
                  <Route path='/accept/trainingcourses' component={TrainingCoursesAcceptList} />
                <Route path='/szukaj/:city?/:disease?' component={AdvancedSearch} />
                  <Route path='/test/:id' component={TestComponent} />
                  <Route path='/routetest/:id' component={RouteTestComponent} />
                <Route path='/physiotherapist/education' component={EducationEditComponent} />
                <Route exact={true} path='/scheduler' component={SchedulerComponent} />
                <Route path='/arrangevisit/firststep' component={ArrangeVisitFirstStepComponent} />
                <Route path='/arrangevisit/secondstep' component={ArrangeVisitSecondStepComponent} />
                <Route path='/arrangevisit/thirdstep/:id' component={ArrangeVisitThirdStepComponent} />
                <Route path='/scheduler/fixedworkhours' component={FixedWorkHoursComponent} />
                <Route path='/visit/list' component={VisitListComponent} />
                <Route path='/visit/view/:id' component={VisitViewComponent} />
                <Route path='/visit/a/view/:id' component={VisitViewAnonymousComponent} />
                <Route path='/myvisits' component={CustomerVisitListComponent} />
                <Route path='/register/final/:id/:token' component={RegisterFinalComponent} />
                <Route path='/passwordrecovery' component={PasswordRecoveryComponent} />
                <Route path='/resetpassword/:id/:code' component={ResetPasswordComponent} />
                <Route path='/favorite/list' component={FavoriteListComponent} />
                <Route path='/register/smsconfirm' component={RegisterCodeConfirm} />
                <Route exact={true} path='/contact' component={ContactComponent} />
                <Route path='*' component={NotFoundComponent} />
                <Route  exact={true} path='/blog' component={Blog} />
                <Route path='/blog/:path' component={BlogArticle} />
                <Route path='/statistics' component={StatisticsComponent} />
                <Route path='/managesitemap' component={SitemapManageComponent} />
                <Route path='/politykaprywatnosci' component={PrivacyPolicy} />
            </Suspense>
          </Layout>
        </GoogleReCaptchaProvider>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.tsx